type Props = {
	text: string;
	color: string;
};

export const OptionNameLabel = ({ text, color }: Props) => {
	return (
		<label style={{ background: color }} className="block rounded-md p-2">
			{text}
		</label>
	);
};
